<template>
  <div
    v-if="blok.url && blok.cover.filename"
    class="content-demo"
    :class="{ 'content-demo--preview': !enabled }"
  >
    <img
      :src="blok.cover.filename"
      :alt="blok.cover.alt"
      class="content-demo__cover"
    />
    <SbButton
      :label="blok.label"
      variant="tertiary"
      class="content-demo__button"
      @click="enableDemo"
    />
    <SbModal
      v-if="enabled && demoUrl"
      :is-open="enabled"
      custom-class="content-demo__modal"
      @hide="enabled = false"
    >
      <iframe
        :src="demoUrl"
        :title="$t('Demo on Navattic')"
        allow="fullscreen"
        height="100%"
        width="100%"
      />
    </SbModal>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useTracking } from '@/store/modules/App/tracking'
import { isString } from '@/utils/checkers'
import { SbButton, SbModal } from '@storyblok/design-system'

const props = defineProps<{
  blok: {
    url: string
    label: string
    cover: {
      filename: string
      alt: string
    }
  }
  title: string
  id: string
}>()

const { analyticsTrack } = useTracking()

const enabled = ref(false)

const demoUrl = computed((): string | null => {
  return isString(props.blok.url) &&
    props.blok.url.startsWith('https://storyblok.navattic.com')
    ? props.blok.url
    : null
})

const enableDemo = (): void => {
  enabled.value = true
  if (props.id) {
    analyticsTrack({
      event: 'click_labs_detail_page_navattic',
      payload: {
        feature_name: props.title,
        context: 'labs',
      },
    })
  } else {
    console.warn('No tracking id provided for demo')
  }
}
</script>

<style lang="scss">
.content-demo {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  min-height: 150px;
  padding: $sb-size-unit-2xl $sb-size-unit-2xl 0;
  background-color: $sb-color-background-secondary;
  border-radius: $sb-border-radius-lg;

  &__modal {
    height: 100%;
    max-width: 100%;

    iframe {
      border: 0;
    }

    .sb-modal__close-button {
      position: absolute;
      right: $sb-size-unit-sm;
      top: $sb-size-unit-sm;
    }
  }

  &__button {
    position: absolute;
    z-index: 1;
  }

  &__cover {
    object-fit: cover;
    width: 100%;
    height: auto;
  }

  &--preview {
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: $sb-color-secondary-950;
      opacity: 0.08;
    }
  }
}
</style>
